import { ref } from 'vue'
import { getCurrentLevelAttr, getTerminalLevel, getTooltipLabel } from '../helpers/DanmarksKortMap.helpers.js'

export function useMapHover(wrapperRef, caches, props, { mapLevel, prefetchRegionData }) {
  const tooltip          = ref({ visible: false, name: '', x: 0, y: 0 })
  const hoveredMarkerKey = ref(null)
  let   hovered          = null

  const clearHover = () => {
    if (!hovered) return
    caches[hovered.groupAttr].group.get(hovered.key)?.forEach(p =>
      p.classList.remove('kb-danmarks-kort-map__path--hovered')
    )
    hovered = null
  }

  const setHover = (groupAttr, key) => {
    if (hovered?.groupAttr === groupAttr && hovered?.key === key) return
    clearHover()
    hovered = { groupAttr, key }
    caches[groupAttr].group.get(key)?.forEach(p =>
      p.classList.add('kb-danmarks-kort-map__path--hovered')
    )
  }

  const onMouseover = (e) => {
    const path = e.target.closest('path[data-name]')
    if (!path) return
    const groupAttr = getCurrentLevelAttr(mapLevel.value, props.flow)
    if (!groupAttr) return

    const key = path.dataset[groupAttr]

    if (mapLevel.value === 'country') {
      setHover(groupAttr, key)
      hoveredMarkerKey.value = key
      prefetchRegionData(key)
      return
    }

    if (mapLevel.value !== getTerminalLevel(props.flow)) setHover(groupAttr, key)
    tooltip.value = { visible: true, name: getTooltipLabel(groupAttr, key, props.flow), x: e.clientX, y: e.clientY }
  }

  const onMousemove = (e) => {
    if (tooltip.value.visible) {
      tooltip.value.x = e.clientX
      tooltip.value.y = e.clientY
    }
  }

  const onMouseleave = (e) => {
    if (e.relatedTarget?.closest?.('.kb-danmarks-kort-map__marker')) return
    clearHover()
    hoveredMarkerKey.value = null
    tooltip.value.visible  = false
  }

  const onMarkerMouseleave = (e) => {
    if (e.relatedTarget?.closest?.('.kb-danmarks-kort-map__svg-wrapper')) return
    clearHover()
    hoveredMarkerKey.value = null
  }

  const showTooltipAtSvgCentroid = (groupAttr, key) => {
    const svgEl = wrapperRef.value?.querySelector('svg')
    if (!svgEl) return
    const centroid = caches[groupAttr]?.centroid.get(key)
    if (!centroid) return
    const ctm = svgEl.getScreenCTM()
    if (!ctm) return
    const pt = svgEl.createSVGPoint()
    pt.x = centroid.cx
    pt.y = centroid.cy
    const screen = pt.matrixTransform(ctm)
    tooltip.value = { visible: true, name: getTooltipLabel(groupAttr, key, props.flow), x: screen.x, y: screen.y }
  }

  return { tooltip, hoveredMarkerKey, setHover, clearHover, onMouseover, onMousemove, onMouseleave, onMarkerMouseleave, showTooltipAtSvgCentroid }
}
